import React, { Fragment, useContext, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Checkbox } from "semantic-ui-react";
import $ from "jquery";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";

const UserAgreements = (props) => {
    const { t } = useTranslation();
    const { data } = props;
    const [user, setUser] = useState({
        terms: data.user_terms_agreement,
        rodo: data.user_rodo_agreement,
        ecc: data.user_ecc_agreement,
        newsletter: data.user_newsletter_agreement,
    });
    const { setAlerts, checkServerData } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [changedForm, setChangedForm] = useState(false);

    const agreements = [
        { value: user.terms, text: t("users.regulationAccept"), name: "terms", req: true },
        { value: user.rodo, text: t("users.rodoAccept"), name: "rodo", req: true },
        { value: user.ecc, text: t("users.mssgAccept"), name: "ecc", req: false },
        { value: user.newsletter, text: t("users.newsletterAccept"), name: "newsletter", req: false },
    ];

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (!user.terms) {
            $("#registerFormig").addClass("is-invalid");
            errors.push(t("error.notCheckedRegulations"));
        }
        if (!user.rodo) {
            $("#registerFormig").addClass("is-invalid");
            errors.push(t("error.notCheckedRodo"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setBlockForm(true);
            setAlerts([{ variant: "info", message: t("info.updatingAgreements") }]);
            updateAgreements();
        }
    };

    const updateAgreements = async () => {
        const res = await postMethod("/update-agreements", { user: user });
        if (checkServerData(res)) {
            setChangedForm(false);
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "changedUserEmail" }]);
        }
        setBlockForm(false);
    };

    return (
        <Fragment>
            <Col xs={12} className="px-4 px-lg-2 ">
                <p className="h5 mt-5 mb-3">{t("users.agreements")}</p>
                <Form onSubmit={checkValidation} autoComplete="off">
                    {agreements.map((e, i) => (
                        <Fragment key={i}>
                            <Checkbox
                                label={
                                    <label className="form-label">
                                        {e.text} {e.req && <span className="req">*</span>}
                                    </label>
                                }
                                id={`addUserForm${e.name}`}
                                checked={e.value}
                                onChange={() => {
                                    setUser({ ...user, [e.name]: !e.value });
                                    setChangedForm(true);
                                }}
                                className="d-block"
                            />
                        </Fragment>
                    ))}
                    <Form.Group className="mb-3 mt-4">
                        <Button variant="primary" type="submit" disabled={blockForm || !changedForm}>
                            {t("saveChanges")}
                        </Button>
                    </Form.Group>
                </Form>
            </Col>
        </Fragment>
    );
};

export default UserAgreements;
